import Vue from 'vue'
import Router from 'vue-router'
import LayoutMain from '@/components/base/LayoutMain'
import LayoutPdf from '@/components/base/LayoutPdf'
import Home from '@/components/Home'
import Sobre from '@/components/Sobre'
import Busca from '@/components/Busca'
import Edicoes from '@/components/Edicoes'
import BuscaLegislacoes from '@/components/BuscaLegislacoes'
import Legislacoes from '@/components/Legislacoes'
import PublicarDiarioOficial from '@/components/PublicarDiarioOficial'
import VerEdicao from '@/components/VerEdicao'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: LayoutMain,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/portal',
          name: 'HomePortal',
          component: Home
        },
        {
          path: '/edicoes',
          name: 'Edições',
          component: Edicoes
        },
        {
          path: '/legislacoes',
          name: 'Legislações',
          component: Legislacoes
        },
        {
          path: '/sobre',
          name: 'Sobre',
          component: Sobre
        },
        {
          path: '/busca',
          name: 'Busca',
          component: Busca
        },
        {
          path: '/busca-legislacoes',
          name: 'Busca de Legislações',
          component: BuscaLegislacoes
        },
        {
          path: '/publicar-no-diario',
          name: 'Publicar no Diário Oficial',
          component: PublicarDiarioOficial
        }
      ]
    },
    {
      path: '/ver-edicao',
      name: 'LayoutPdf',
      component: LayoutPdf,
      children: [
        {
          path: '/ver-edicao',
          name: 'Ver Edição',
          component: VerEdicao
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js